import { RiMentalHealthFill } from 'react-icons/ri';
import { BsFillLightningFill } from 'react-icons/bs';
import { RiRestaurantFill } from 'react-icons/ri';
import { FaBed } from 'react-icons/fa';

export const Intolerance = [
  {
    name: 'celery-free',
    title: 'Celery Free',
  },
  {
    name: 'crustacean-free',
    title: 'Crustacean Free',
  },
  {
    name: 'dairy-free',
    title: 'Dairy Free',
  },
  {
    name: 'egg-free',
    title: 'Egg Free',
  },
  {
    name: 'fish-free',
    title: 'Fish Free',
  },
  {
    name: 'gluten-free',
    title: 'Gluten Free',
  },
  {
    name: 'wheat-free',
    title: 'Wheat Free',
  },
  {
    name: 'sesame-free',
    title: 'Sesame Free',
  },
  {
    name: 'shelfish-free',
    title: 'Shelfish Free',
  },
  {
    name: 'soy-free',
    title: 'Soy Free',
  },
];

export const Cuisine = [
  {
    name: 'American',
    title: 'American',
  },
  {
    name: 'Asian',
    title: 'Asian',
  },
  {
    name: 'British',
    title: 'British',
  },
  {
    name: 'Caribbean',
    title: 'Caribbean',
  },
  {
    name: 'Central Europe',
    title: 'Central Europe',
  },
  {
    name: 'Chinese',
    title: 'Chinese',
  },
  {
    name: 'Eastern Europe',
    title: 'Eastern Europe',
  },
  {
    name: 'French',
    title: 'French',
  },
  {
    name: 'Indian',
    title: 'Indian',
  },
  {
    name: 'Italian',
    title: 'Italian',
  },
  {
    name: 'Japanese',
    title: 'Japanese',
  },
  {
    name: 'Mediteranean',
    title: 'Mediteranean',
  },
  {
    name: 'Mexican',
    title: 'Mexican',
  },
  {
    name: 'Middle Eastern',
    title: 'Middle Eastern',
  },
  {
    name: 'Nordic',
    title: 'Nordic',
  },
  {
    name: 'South American',
    title: 'South American',
  },
];

export const ProfileCard = [
  {
    icon: <RiMentalHealthFill />,
    id: 1,
  },
  {
    icon: <BsFillLightningFill />,
    id: 2,
  },
  {
    icon: <FaBed />,
    id: 3,
  },
  {
    icon: <RiRestaurantFill />,
    id: 4,
  },
];

export const article1 = [
  {
    id: 1,
    title: 'Myths and Facts',
    img: '/assets/mythsCover.jpg',
    url: '/myths1',
  },

  {
    id: 2,
    title: 'Nutrition Guide',
    img: 'assets/nutritionb.jpg',
    url: '/nutrition1',
  },

  {
    id: 3,
    title: 'Top foods to eat',
    img: 'assets/eatt.jpg',
    url: '/foods1',
  },
];

export const article2 = [
  {
    id: 1,
    title: 'Myths and Facts',
    img: '/assets/thinking.jpg',
    url: '/myths2',
  },

  {
    id: 2,
    title: 'Nutrition Guide',
    img: '/assets/bunp.jpg',
    url: 'nutrition2',
  },
  {
    id: 3,
    title: 'Top foods to eat',
    img: '/assets/eats.jpg',
    url: '/foods2',
  },
];

export const article3 = [
  {
    id: 1,
    title: 'Myths and Facts',
    img: '/assets/new.jpg',
    url: '/myths3',
  },

  {
    id: 2,
    title: 'Nutrition Guide',
    img: '/assets/N3.jpg',
    url: '/nutrition3',
  },
  {
    id: 3,
    title: 'Top foods to eat',
    img: '/assets/new3.jpg',
    url: '/foods3',
  },
];

export const myths1 = [
  {
    title: 'Being on the pill for too long will delay pregnancy',
    desc: 'This is a myth. If you’ve spent years of your life trying not to get pregnant, it’s only natural to wonder if it will take a while to get things back on track. In good news, it won’t. For some women, fertility returns as soon as they stop using the pill, but for others, it may take a month or so to resume ovulation — as long as there are no other issues going on, of course.',
    img: '/assets/TryingToConceive/Myths/myth1.jpg',
  },
  {
    title: 'Boxers are better than briefs when you are trying to conceive',
    desc: "This is a myth. When your partner gets overheated — whether he’s in a hot tub, in a sauna, exercising in spandex bike shorts or wearing tighty-whities — his sperm production could go down. That said, though, in most cases, it’s not enough to make a big difference.'",
    img: '/assets/TryingToConceive/Myths/myth2.jpg',
  },
  {
    title: 'After an egg is released, it can be fertilized for up to two days',
    desc: "This is a myth. While sperm can hang out and wait for their date for three days or more, an egg has only a 12- to 24-hour shelf life. So sperm have to catch it while they can. Timing is just about everything when it comes to fertility, which is why knowing the signs of ovulation (and pinpointing when you're ovulating) is so key to conception success.",
    img: '/assets/TryingToConceive/Myths/myth3.jpg',
  },
  {
    title: 'Position matters',
    desc: 'This is a myth, for the most part. Healthy sperm are excellent swimmers — and determined on their mission. Pretty much any position can get you pregnant, so you might as well pick a position you both like. If you want to add a little extra gravity into the equation, give sperm a head start by elevating your hips slightly and asking your partner to be on top.',
    img: '/assets/TryingToConceive/Myths/myth4.jpg',
  },

  {
    title:
      'You’re more likely to experience fertility challenges if you’re a first-timer',
    desc: 'This is a myth. Secondary infertility — when a couple has trouble conceiving after they’ve already had one or more babies — is about as common as primary infertility, when first-timers have trouble. In fact, 60 percent of all cases of infertility are experienced by couples who have already filled their nest at least once.',
    img: '/assets/TryingToConceive/Myths/myth5.jpg',
  },
  {
    title: 'The average couple conceives within three months of trying',
    desc: 'This is a myth. Conception doesn’t typically happen overnight — even after a really hot night. Egg and sperm may meet up on your first try, of course, but it can take the average couple who doesn’t have any fertility issues up to 12 months of active efforts before your conception mission is accomplished.',
    img: '/assets/TryingToConceive/Myths/myth6.jpg',
  },
];

export const nutrition1 = [
  {
    title: 'Folic acid',
    desc: 'All women need to take folic acid tablets before getting pregnant to build up the level of folic acid in their body to give maximum protection to the baby against neural tube defects such as spina bifida. It is almost impossible to get enough folic acid through your diet to give the most protection.',
    img: '/assets/TryingToConceive/Nutrition/N1.jpg',
  },
  {
    title: 'Vitamin D',
    desc: 'Vitamin D in pregnancy is important for the development of strong bones. Some women are at greater risk of vitamin D deficiency and could also benefit from a vitamin D supplement of 10mcg a day before and during pregnancy.',
    img: '/assets/TryingToConceive/Nutrition/N2.jpg',
  },
  {
    title: 'Caffeine',
    desc: 'Caffeine is found in coffee, tea, some soft drinks and energy drinks. Having more than 200mg of caffeine a day (two mugs of instant coffee a day or one mug of filter coffee) is harmful to a baby in the womb so it is safer to avoid caffeine as soon as you stop contraception.',
    img: '/assets/TryingToConceive/Nutrition/N3.jpg',
  },
  {
    title: 'Anaemia (low iron in the blood)',
    desc: 'If you have anaemia it needs treatment before you get pregnant. Speak to your GP if you think you have symptoms of anaemia. A blood test will show if you are anaemic. Iron deficiency anaemia is treated with iron supplement tablets. You may be advised to eat more food with lots of iron in it, such as:',
    img: '/assets/TryingToConceive/Nutrition/N4.jpg',
  },
  {
    title: 'Dental care',
    desc: 'Some dental check ups involve having an X-ray. Even though most dental X-rays don’t affect the stomach or pelvic area, your dentist will usually want to wait until you’ve had the baby. With this in mind, it’s a good idea to visit the dentist before you get pregnant, just in case you need any more treatment.',
    img: '/assets/TryingToConceive/Nutrition/N5.jpg',
  },
  {
    title: 'Preservatives and additives',
    desc: 'Try to avoid too much ready-prepared food too. The chemical preservatives, colourings, and flavourings added to these can affect the nutrients in the food.',
    img: '/assets/TryingToConceive/Nutrition/N6.jpg',
  },
];

export const foods1 = [
  {
    title: 'Eat foods rich in antioxidants',
    desc: 'Antioxidants like folate and zinc may improve fertility for both men and women. They deactivate the free radicals in your body, which can damage both sperm and egg cells.Foods such as fruits, vegetables, nuts, and grains are packed full of beneficial antioxidants like vitamins C and E, folate, beta carotene, and lutein. Eating more of these healthy foods shouldn’t hurt in the effort',
    img: '/assets/TryingToConceive/Food/F1.jpg',
  },
  {
    title: 'Eat a bigger breakfast',
    desc: 'Eating a substantial breakfast may help women with fertility problems. One study found that eating a larger breakfast may improve the hormonal effects of polycystic ovary syndrome (PCOS), a major cause of infertility.For moderate weight women with PCOS, eating most of their calories at breakfast reduced insulin levels by 8 percent and testosterone levels by 50 percent. High levels of either can contribute to infertility.',
    img: '/assets/TryingToConceive/Food/F2.jpg',
  },
  {
    title: 'Avoid trans fats',
    desc: 'Eating healthy fats every day is important for boosting fertility and overall health.However, trans fats are associated with an increased risk of ovulatory infertility, due to their negative effects on insulin sensitivity. Trans fats are commonly found in hydrogenated vegetable oils and are usually present in some margarine, fried foods, processed products, and baked goods. Some of the faves, we know.',
    img: '/assets/TryingToConceive/Food/F3.jpg',
  },
  {
    title: 'Eat fewer refined carbs',
    desc: 'Speaking of carbs: It’s not just the amount of carbs that’s important, but also the type.Refined carbs may be especially problematic. Refined carbs include sugary foods and drinks and processed grains, including white pasta, bread, and rice. These carbs are absorbed very quickly, causing spikes in blood sugar and insulin levels. Refined carbs also have a high glycemic index (GI). The GI tells you if a carbohydrate-dense food will raise your blood sugar significantly.',
    img: '/assets/TryingToConceive/Food/F4.jpg',
  },
  {
    title: 'Swap protein sources',
    desc: 'Replacing some animal proteins (such as meat, fish, and eggs) with vegetable protein sources (such as beans, nuts, and seeds) is linked to a reduced risk of infertility.A study showed that when 5 percent of total calories came from vegetable protein instead of animal protein, the risk of ovulatory infertility decreased by more than 50 percentTrusted Source.A 2018 study concluded that eating more fishTrusted Source correlates to a higher probability of live birth following infertility treatment.',
    img: '/assets/TryingToConceive/Food/F5.jpg',
  },
  {
    title: 'Add in a multivitamin',
    desc: 'If you take multivitamins, you may be less likely to experience ovulatory infertility.In fact, an estimated 20 percentTrusted Source of ovulatory infertility may be avoided if women consume 3 or more multivitamins per week. Micronutrients found in vitamins have essential rolesTrusted Source in fertility.For people trying to get pregnant, a multivitamin containing folate may be especially beneficial.',
    img: '/assets/TryingToConceive/Food/F6.jpg',
  },
];
export const myths2 = [
  {
    title: 'Stress during pregnancy is always bad for the fetus.',
    desc: "REALITY: New research shows that a moderate level of stress is actually good for the fetus: It tones the fetus's nervous system and accelerates its development. Women who experienced moderate stress during pregnancy have two-week-old infants with brains that work at a faster speed than infants of mothers without the same stress, and two-year old toddlers with higher motor and mental development scores.",
    img: '/assets/Pregnant/Myths/M1.jpg',
  },
  {
    title: 'Pregnant women should avoid exercise.',
    desc: ' Actually, when a pregnant woman exercises, her fetus gets a beneficial workout, too. Research shows that the fetuses of pregnant women who are physically active have heart rates that are slower and more variable; both signs of cardiovascular health. The babies of exercisers have lower birth weights, and may even become more intelligent adults because of their bigger brains.',
    img: '/assets/M2missing.jpeg',
  },
  {
    title:
      'A fetus is sealed away in the uterus, unaffected by whats going on outside.',
    desc: " Much of what a pregnant woman encounters in her daily life -- the air she breathes, the food and drink she consumes, the chemicals she's exposed to -- are shared in some fashion with her fetus. Pregnant women can protect their fetuses by abstaining from alcohol and cigarettes, by purchasing plastic products that are phthalate- and BPA-free, and by not putting plastic containers in the microwave or dishwasher.",
    img: '/assets/Pregnant/Myths/M3.jpg',
  },
  {
    title: 'You cant be active during your pregnancy',
    desc: 'It’s better for you and your baby if you stay active during pregnancy. It’s safe and healthy. So long as your pregnancy has no complications you can do the same exercise that you did before you were pregnant (with a few unusual exceptions).',
    img: '/assets/Pregnant/Myths/M4.jpg',
  },
  {
    title: 'You dont need to eat for two',
    desc: "Most women will only only need to have 200 extra calories (on top of the 2,000 daily recommendation), and that’s only in the third trimester. 'That is an old myth' says Julie Redfern, RD, LDN, a registered dietitian at Brigham and Women's Hospital in Boston. 'Many women who do 'eat for two' end up gaining an excessive amount of weight.'",
    img: '/assets/Pregnant/Myths/M5.jpg',
  },
  {
    title: 'You dont have to be glowing and happy all the time',
    desc: 'Pregnancy hormones can often be to blame for highs and lows, not to mention coping with pregnancy niggles, the sometimes crippling exhaustion, worrying about giving birth and the responsibilities of parenthood. It can be pretty overwhelming, so if you’re not feeling the glow, you’re not alone - far from it. If your mood, or worries, are getting in the way of daily life, don’t hesitate to talk to your midwife.',
    img: '/assets/Pregnant/Myths/M6.jpg',
  },
];

export const nutrition2 = [
  {
    title: 'Avoid potentially dangerous foods',
    desc: 'Some foods have a higher risk of carrying microbes that cause food borne illness and are potentially harmful to your baby. Avoid raw or undercooked foods like eggs and meat. Don’t eat fish that could contain high levels of mercury (i.e. king mackerel, marlin, orange roughy, shark, swordfish, tilefish, and tuna) or raw seafood, like sushi or clams. Stay away from soft cheeses like brie and feta as they are generally not pasteurized.',
    img: '/assets/Pregnant/Nutrition/N1.jpeg',
  },
  {
    title: 'Reach for food rich in folic acid',
    desc: 'Folic acid is one of the most important vitamins during pregnancy because it helps with brain and spinal cord development. Having enough folic acid is important from the very first days of pregnancy. Be sure to eat plenty of legumes (like black, pinto or garbanzo beans), green leafy vegetables, and citrus. Most cereals and grains are fortified with folic acid as well. Taking your prenatal vitamin will also ensure you get enough folic acid.',
    img: '/assets/Pregnant/Nutrition/N2.jpg',
  },
  {
    title: 'Incorporate foods high in iron',
    desc: 'The amount of blood in your body will increase by about 50% during pregnancy, and iron plays a large role in blood production. Your prenatal vitamin will help meet some of your iron needs (try taking it at night and with food if it makes you feel nauseous), but also eat foods high in iron like lean meats (red meat is especially high in iron), legumes, and dark green leafy vegetables like spinach. Eating a good source of vitamin C (like oranges) with these foods will help the iron be absorbed better.',
    img: '/assets/Pregnant/Nutrition/N3.jpg',
  },
  {
    title: 'Increase your fiber',
    desc: 'Being pregnant can cause constipation (and sometimes uncomfortable hemorrhoids). Eating foods that are high in fiber can help keep your digestive system healthy; plus it helps keep you full and has additional health benefits. Try whole grain breads and cereal and include plenty of fresh fruits and vegetables.',
    img: '/assets/N4missing.jpeg',
  },
  {
    title: 'Include enough calcium',
    desc: 'Your baby needs calcium to grow healthy bones and teeth. If the baby doesn’t get enough calcium from what you consume, then she will take calcium from your bones. To prevent this, add more calcium rich foods in your diet. Dairy foods like milk, yogurt, and cheese have a lot of calcium, but so do some non-dairy foods like broccoli, spinach, and almonds.',
    img: '/assets/Pregnant/Nutrition/N5.jpg',
  },
  {
    title: 'Remember quality is better than quantity',
    desc: 'It is easy to convince yourself that eating for two means that you can eat whatever you want. But, in reality, you only need a few hundred extra calories a day and a lot more nutrients than you normally do. Be sure that most of your food choices are nutrient dense and not just empty calories. For example, a half of veggie sandwich on whole wheat bread (nutrient dense) for a snack is a better choice than a donut (empty calories).',
    img: '/assets/Pregnant/Nutrition/N6.jpg',
  },
];
export const foods2 = [
  {
    title: 'Lentils',
    desc: "Lentils are also rich in the B vitamin folate (called folic acid in supplements), which is vital to forming your baby's brain and nervous system and has a powerful protective effect against neural-tube defects like spina bifida, a birth disorder in which a spine does not form properly. Lentils are also high in fiber, which can keep your digestive system humming along and help stave off pregnancy-related constipation.",
    img: '/assets/Pregnant/Food/F1.jpg',
  },
  {
    title: 'Yogurt',
    desc: 'Your baby needs a steady supply of calcium for his growing bones, and you need it to keep yours strong and help your nerves and muscles function. Three to four servings of dairy foods can help you meet your daily calcium needs, and yogurt is one of your best bets.',
    img: '/assets/Pregnant/Food/F2.jpg',
  },
  {
    title: 'Wild salmon',
    desc: 'The fatty fish earns its rep for being one of the best foods to eat while pregnant. Cold-water fish like salmon are packed with DHA omega-3s, which are essential for a number of reasons: the body can’t make them on its own; they help metabolize fat-soluble vitamins like A and E; they may help reduce the risk of prenatal depression; and they’re critical for the development of your baby’s eyes and brain (both the brain and retina are primarily composed of DHA). Salmon, too, is a good source of iodine.',
    img: '/assets/Pregnant/Food/F3.jpg',
  },
  {
    title: 'Avocado',
    desc: 'The creamy green fruit is full of folate, along with vitamin B6, which promotes healthy tissue and brain growth for baby and could help ease morning sickness for you.',
    img: '/assets/Pregnant/Food/F4.jpg',
  },
  {
    title: 'Edamame',
    desc: "You might know that the cooked soybean pods are a tasty source of vegetarian protein, serving up 18 grams per cup shelled. But they're rich in other important pregnancy nutrients, too. A cup of edamame offers up nearly 100 milligrams of calcium, 3.5 milligrams of iron and 482 micrograms of folate",
    img: '/assets/Pregnant/Food/F5.jpg',
  },
  {
    title: 'Nuts',
    desc: 'Talk about small but mighty. Nuts are chock-full of important vitamins and minerals like magnesium, zinc, potassium and vitamin E, along with protein, fiber and healthy fats. Plus, they’re easily portable, making them an ideal on-the-go pregnancy snack.',
    img: '/assets/Pregnant/Food/F6.jpg',
  },
];

export const myths3 = [
  {
    title:
      'It is selfish to put yourself first. You should be 100% devoted to your baby and your family.',
    desc: 'Nope. Like they say on the airplane: You need to put your own oxygen mask on first. You deserve to be okay, because you matter.And lets be frank here- if you’re not okay, no one is okay.You are as much of a priority as your baby. Full stop.',
    img: '/assets/NewMum/Myths/M1.jpg',
  },
  {
    title: 'You should enjoy every second.',
    desc: 'You can love your baby but not love every second of the early postpartum experience.You’re still a great parent even if you don’t love every second of parenting.Once more: Your experience matters. Allow yourself to be human. Allow yourself to feel your feelings. Don’t put pressure on yourself to enjoy the shitty and the mundane.',
    img: '/assets/NewMum/Myths/M2.jpg',
  },
  {
    title: 'You need to get your “body back” as quickly as possible.',
    desc: 'Bodies change shape. Depending on where you are postpartum, your’s may still be changing shape. It might get closer to the shape it was before your pregnancy. But also, it might not. I get it. Learning to feel at home in your body after pregnancy can be challenging. And while I urge you to honor your feelings, please also dive into the WHY. If losing weight feels like a high priority in the early weeks postpartum, consider examining the deeper pain points.',
    img: '/assets/NewMum/Myths/M3.jpg',
  },
  {
    title: 'You can’t do the things you want to do because you had a baby.',
    desc: 'If you think you can’t, and your reasoning has anything to do with peeing yourself, a prolapsed organ or lack of strength- let’s talk. I watch folks give birth on the regular and birthing is as badass as it gets. If you can do that- no matter how that baby was born- I’m pretty confident we can help you do just about anything else.',
    img: '/assets/M4missing.jpeg',
  },
  {
    title: 'You can go back to your old exercise routine after 6 weeks',
    desc: 'This is one of the most pervasive myths in postpartum recovery. As far as exercise goes, your six-week check up is nothing more than a green-light to progress back to gentle exercise.This myth persists, at least in part, because we are all so damn ready to feel like ourselves again. And because there is so much pressure to get back to the “pre-baby” body.',
    img: '/assets/M5missing.jpeg',
  },
  {
    title: 'It’s normal to pee your pants after pregnancy.',
    desc: 'Involuntary leakage of pee, poo or gas- can be a side effect of a bunch of things. It can be a side effect of a weak or mis-coordindated core and pelvic floor. It can be a side effect of a too tight pelvic floor. Of a prolapse. Depending on the cause of your sneak pee, you’ll need a different treatment plan.  If you are peeing your pants, beyond your first 6 weeks postpartum, it’s worthwhile to seek professional guidance. I recommend all postpartum people visit a pelvic health physical therapist. They’ll help you figure out WHY you are leaking and help you develop a long term strategy to deal with the problem.',
    img: '/assets/NewMum/Myths/M6.jpg',
  },
];
export const nutrition3 = [
  {
    title: 'Stay hydrated all day long',
    desc: 'Dara Godfrey, MS, RD, registered dietician for Reproductive Medicine Associates of New York, says hydration, especially if breastfeeding, is critical. She recommends up to 3 liters of water daily. However, hydration needs can vary so it’s best to let thirst be your guide. A good way to gauge hydration is looking at the color of your urine. Pale yellow urine indicates proper hydration while dark-colored urine indicates that you may be dehydrated and need to up your water intake',
    img: '/assets/NewMum/Nutrition/N1.jpg',
  },
  {
    title: 'Avoid fish high in mercury',
    desc: 'f you’re breastfeeding, avoid high-mercury seafood and fish like orange roughy, tuna, king mackerel, marlin, shark, swordfish, or tilefish. Instead, opt for salmon, shrimp, cod, tilapia, trout, and halibut, among others.',
    img: '/assets/NewMum/Nutrition/N2.jpg',
  },
  {
    title: 'Limit alcohol while breastfeeding',
    desc: 'Although many women decide to avoid alcohol while breastfeeding, if you choose to drink, do so in moderation, and try to limit it to after breastfeeding or wait 2 to 3 hours after having a drink to breastfeed.',
    img: '/assets/NewMum/Nutrition/N3.jpg',
  },
  {
    title: 'Iodine intake.',
    desc: 'Many lactating women fall short of getting enough of this trace mineral, especially those who don’t eat dairy, shun table salt, smoke or eat a lot of foods that inhibit iodine intake (including certain cruciferous veggies). Iodine supports infant growth and brain development. Lactating women should get 290 micrograms per day, nearly double the pre-pregnancy recommended daily amount (RDA) of 150 micrograms. One-quarter teaspoon of iodized table salt provides 76 micrograms, but many brands of sea salt and Kosher salt don’t add iodine, so check nutrition labels. Good dietary sources of iodine include seafood, seaweed, milk, yogurt and cheese.',
    img: '/assets/NewMum/Nutrition/N4.jpg',
  },
  {
    title: 'Omega-3 fatty acids.',
    desc: 'Just as in pregnancy, lactating women should consume 8 to 12 ounces of fish per week. Opt for varieties low in mercury and high in eicosapentaenoic acid (EPA) and docosahexaenoic acid (DHA), such as salmon, anchovies, sardines and trout. DHA, in particular, is important for fetal brain development. ',
    img: '/assets/NewMum/Nutrition/N5.jpg',
  },
  {
    title: 'Quality of food choices',
    desc: "Choose a variety of lean proteins, fruits, veggies, whole grains and healthy fats. By sticking with natural, whole foods, you’ll get the vitamins, minerals and fiber you need to sustain your energy and keep your body well-nourished while you’re nursing. Contrary to what you may have heard, spicy foods, dairy, caffeine and certain vegetables won't necessarily make baby gassy, so unless your little one seems to be having a lot of gas or digestive issues, you don't have to steer clear.",
    img: '/assets/NewMum/Nutrition/N6.jpg',
  },
];

export const foods3 = [
  {
    title: 'Oatmeal',
    desc: "This complex carb is high in fiber and protein, so it will fill you up and keep you satisfied. Oats are also said to help with milk production if you're breastfeeding.",
    img: '/assets/NewMum/Food/F1.jpg',
  },
  {
    title: 'Whole grain bread',
    desc: 'This staple is great because you can eat it as is or with a topping of your choice. Eat it fresh or freeze it and defrost slice by slice to preserve it – either way, you will get the protein and fiber you need whether it be for breakfast, lunch or dinner.',
    img: '/assets/NewMum/Food/F2.jpg',
  },
  {
    title: ' Eggs',
    desc: 'Possibly the most versatile staple, eggs are great for any meal. It takes less than 5 minutes to scramble them up, and if you have time, hard boiling a few at the beginning of the week will ensure you have a protein-filled snack ready to go when you need it. Eggs also contain a lot of nutrients and vitamins that can assist in recovering from birth.',
    img: '/assets/NewMum/Food/F3.jpg',
  },
  {
    title: 'Frozen fruit and veggies',
    desc: "It can be hard to keep fresh fruit and veggies in the house in the early days when the idea of washing, chopping and cooking seems like too much to handle. Frozen is the perfect solution to making sure they don't go bad. Pop them in the microwave to thaw or blend frozen for a smoothie anytime.",
    img: '/assets/NewMum/Food/F4.jpg',
  },
  {
    title: 'Apples',
    desc: 'Like sweet potatoes, this staple has a longer shelf life than most other fruits and when eaten with nut butter, is the perfect mix of protein, healthy fat and complex carbs to keep your energy up.',
    img: '/assets/NewMum/Food/F5.jpg',
  },
  {
    title: 'Canned beans',
    desc: 'The high fiber content in beans will keep your digestive system moving along, which is important following a vaginal birth or c-section. They are also a great source of protein and can be added to any meal for a nutritional boost.',
    img: '/assets/F6missing.jpeg',
  },
];

export const trimesterCard = [
  {
    id: 1,
    title: 'First Trimester',
    img: '/assets/trimester1.png',
    url: '/trimester1',
  },

  {
    id: 2,
    title: 'Second trimester',
    img: '/assets/trimester2.png',
    url: '/trimester2',
  },
  {
    id: 3,
    title: 'Third Trimester',
    img: '/assets/trimester3.png',
    url: '/trimester3',
  },
];

export const tipsCard1 = [
  {
    id: 1,
    img: '/assets/tips1.png',
    desc: 'The first 3 months can be the most diffcult, surround yourself with a strong support network to help you when needs be.',
  },
  {
    id: 2,
    img: '/assets/tips2.png',
    desc: 'Alot is changing during this period.Take time to connect with your baby and prepare yourself for this journey.',
  },
  {
    id: 3,
    img: '/assets/tips3.png',
    desc: 'Its easy to forget yourself when youre pregnant, but you are the vessel, help your baby by helping yourself.',
  },
  {
    id: 4,
    img: '/assets/tips4.png',
    desc: 'Keep an eye on what you are eating and which foods benefit you and your baby.',
  },
];

export const tipsCard2 = [
  {
    // id: 1,
    img: '/assets/tips1.png',
    desc: 'Youll see that your clothes will start to get tight, invest in some loose items of clothing to feel at ease',
  },
  {
    // id: 2,
    img: '/assets/tips2.png',
    desc: 'Your breasts will change shape during this period, its a good idea to start looking for maternity bras',
  },
  {
    // id: 3,
    img: '/assets/tips3.png',
    desc: 'Watch out for pica, a compulsive eatinf disorder which leads to eating non food items',
  },
  {
    // id: 4,
    img: '/assets/tips4.png',
    desc: 'Eat alot of energt boosters such as brocoli, blueberries, chicken and water',
  },
];

export const tipsCard3 = [
  {
    // id: 1,
    img: '/assets/tips1.png',
    desc: ' Preeclampsia Warning Signs. If your head is throbbing non-stop, you feel very swollen, or youve got blurred vision, see your doctor right away.',
  },
  {
    // id: 2,
    img: '/assets/tips2.png',
    desc: 'Go for a Swim. Swimming is a great way to exercise in late pregnancy.',
  },
  {
    // id: 3,
    img: '/assets/tips3.png',
    desc: 'Consider Cord Blood Banking. Find out about donating your babys cord blood. You may be able to use the stem cells if your baby gets sick',
  },
  {
    // id: 4,
    img: '/assets/tips4.png',
    desc: ' Learn Infant CPR. To make sure youre ready for any emergency once your baby arrives, take an infant CPR or first aid class.',
  },
];

export const symptomsCard1 = [
  {
    title: 'Morning sickness',
    desc: 'Morning sickness begins one month after you become pregnant. This might be due to rising hormone levels. To help relieve nausea, avoid having an empty stomach',
    img: '/assets/Symptoms/S1.jpg',
  },
  {
    title: 'Food cravings and aversions.',
    desc: 'When youre pregnant, you might become more sensitive to certain odors and your sense of taste might change. Like most other symptoms of pregnancy, food preferences can be chalked up to hormonal changes.',
    img: '/assets/cravings.jpg',
  },
  {
    title: 'Increased urination. ',
    desc: 'You might find yourself urinating more often than usual. The amount of blood in your body increases during pregnancy, causing your kidneys to process extra fluid that ends up in your bladder.',
    img: '/assets/toilet2.jpg',
  },
  {
    title: 'Fatigue. ',
    desc: 'During early pregnancy, levels of the hormone progesterone soar — which can put you to sleep. Rest as much as you can. A healthy diet and exercise might increase your energy.',
    img: '/assets/sleep.jpg',
  },
];

export const symptomsCard2 = [
  {
    title: 'Nasal problems.',
    desc: 'During pregnancy, hormone levels increase and your body makes more blood. This can cause your mucous membranes to swell and bleed easily, resulting in stuffiness and nosebleeds. Saline drops or a saline rinse can help relieve congestion.',
    img: '/assets/symptoms/S2.jpg',
  },
  {
    title: 'Dental issues.',
    desc: 'Pregnancy can cause your gums to become more sensitive to flossing and brushing, resulting in minor bleeding. Rinsing with salt water and switching to a softer toothbrush can decrease irritation',
    img: '/assets/symptoms/S3.jpg',
  },
  {
    title: 'Leg cramps.',
    desc: 'Leg cramps are the feeling of sudden, sharp pain, usually in the calf muscles or feet. They can last from a few seconds to 10 minutes and it can even be difficult to move when they hit. Even when the leg cramp has stopped, you might feel tenderness in the muscle for up to 24 hours.',
    img: '/assets/symptoms/S4.jpg',
  },
  {
    title: 'Vaginal discharge.',
    desc: 'You might notice a sticky, clear or white vaginal discharge. This is normal. Contact your health care provider if the discharge becomes strong smelling, unusual in color.',
    img: '/assets/symptoms/S5.jpg',
  },
];

export const symptomsCard3 = [
  {
    title: 'Braxton Hicks contractions',
    desc: 'You might feel these mild, irregular contractions as a slight tightness in your abdomen. Theyre more likely to occur in the afternoon or evening, after physical activity or after sex.',
    img: '/assets/symptoms/S31.jpg',
  },
  {
    title: 'Backaches.',
    desc: 'Pregnancy hormones relax the connective tissue that holds your bones in place, especially in the pelvic area. These changes can be tough on your back, and often result in discomfort during the third trimester.',
    img: '/assets/Backache.jpg',
  },
  {
    title: 'Frequent urination',
    desc: 'As your baby moves deeper into your pelvis, youll feel more pressure on your bladder. You might find yourself urinating more often. This extra pressure might also cause you to leak urine — especially when you laugh, cough, sneeze, bend or lift',
    img: '/assets/symptoms/S32.jpg',
  },
  {
    title: 'Spider veins, varicose veins and hemorrhoids.',
    desc: 'Increased blood circulation might cause tiny red-purplish veins (spider veins) to appear on your face, neck and arms. Redness typically fades after delivery. You might also notice swollen veins (varicose veins) on your legs.  ',
    img: '/assets/symptoms/S35.jpg',
  },
];

export const cravings = [
  {
    id: 1,
    img: '/assets/slide1.png',
    desc: 'One of the perks of being a cauliflower is being super low-carb and low-calorie. This trending crucifer is making its way into all of your favorite recipes: pizza, mashed potatoes, and even fried rice. ',
    title: 'Replace rice with cauliflower',
  },
  {
    id: 2,
    img: '/assets/slide2.png',
    desc: 'It can be easy to go overboard when it comes to snacking, particularly when crunchy, salty chips are involved. While there is no need to deprive yourself of lifes simple pleasures (we are looking at you, potato chips), why not try a healthier version? Make your own chips right in your oven using vegetables.',
    title: 'Swap chips for baked veggies',
  },
  {
    id: 3,
    img: '/assets/slide3.png',
    desc: 'Cut out the refined sugar and treat yourself to a trail mix of choice@ Simply mix together your favourite nuts, dired fruit and a couple of dark chocolate chunks.',
    title: 'Swap Candy for Homemade Chocolate Trail Mix',
  },
  {
    id: 4,
    img: '/assets/slide4.png',
    desc: 'You can source fibre packed bread from your local supermarket, apply a thin layer of your favourite spread and some fruit...voila!',
    title: 'Replace cereal for a fibre packed breakfast',
  },
  {
    id: 5,
    img: '/assets/bread.jpg',
    desc: 'Sometimes that second piece of bread is really unnecessary. By eating your lunch open faced, you cut 120 calories. And if you take it with a fork and knife, youll eat more slowly, allowing your body to tell you when you feel full before youve scarfed down the whole thing.',
    title: 'Swap 2 slices for one',
  },
  {
    id: 6,
    img: '/assets/water1.jpg',
    desc: 'It is important to stay hydrated through pregnancy, but many of us are drinking a lot of extra sugar at the same time. A bottle of water contains 0g of sugar, in comparison to a bottle of fizzy drink which can contain around 54g of sugar.',
    title: 'Changing up your drinks',
  },
];

export const recArticles = [
  {
    id: 1,
    title: 'Time: 2 min read',
    desc: 'Rules forcing women to give birth alone caused widespread distress',
    img: '/assets/recArticle1.png',
    more: 'https://www.independent.co.uk/news/health/pregnant-women-covid-rules-anxiety-distress-b1875740.html',
  },
  {
    id: 2,
    title: 'Time: 4 min read',
    desc: 'The lessons we can learn from experiences of birth during coronavirus',
    img: '/assets/recArticles/recArticle1.png',
    more: 'https://www.independent.co.uk/health_and_wellbeing/giving-birth-coronavirus-pandemic-covid-b1877166.html',
  },
  {
    id: 3,
    title: 'Time: 5 min read',
    desc: 'Pregnant women victims of microaggressions at work, study finds',
    img: '/assets/recArticles/recArticle2.png',
    more: 'https://www.independent.co.uk/news/uk/home-news/pregnant-women-uk-work-culture-b1911965.html',
  },
  {
    id: 4,
    title: 'Time: 8 min read',
    desc: 'Keto diets place pregnant women and kidney disease patients at risk ',
    img: '/assets/recArticles/recArticle3.png',
    more: 'https://www.openaccessgovernment.org/keto-diet-risk-to-pregnant-women-and-kidney-disease-patients/116722/',
  },
  {
    id: 5,
    title: 'Time: 6 min read',
    desc: 'Should I be worried about weight gain during pregnancy?',
    img: '/assets/recArticles/recArticle4.png',
    more: 'https://www.whattoexpect.com/pregnancy/weight-gain/',
  },
  {
    id: 6,
    title: 'Time: 2 min read',
    desc: 'One in five women actively trying to get pregnant smoke cigarettes',
    img: '/assets/recArticles/recArticle5.png',
    more: 'https://www.independent.co.uk/news/uk/home-news/pregnancy-cigarettes-alcohol-women-fertility-health-b1891381.html',
  },
];
